import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../services/store';

const Root = () => {
  const user = useAppSelector(state => state.userReducer.profile);
  const navigate = useNavigate();

  if (user.role == 'SUPER_ADMIN') {
    navigate('/dashboard')
  } else if (user.role == 'OPERATOR') {
    navigate('/order')
  } else {
    navigate('/login')
  }
  return <></>
};
export default Root;